import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a79c9b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "modal-header",
  class: "card shadow-sm mb-2 bg-white rounded"
}
const _hoisted_2 = {
  id: "header-loading",
  class: "text-center mt-3"
}
const _hoisted_3 = { class: "fa-2x" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading header...")
], -1))
const _hoisted_5 = {
  key: 0,
  id: "header-content",
  class: "card-body position-relative"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = {
  key: 0,
  id: "dept-summary"
}
const _hoisted_8 = { class: "card-title" }
const _hoisted_9 = { class: "text-muted" }
const _hoisted_10 = { class: "card-title" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar" }, null, -1))
const _hoisted_12 = { class: "font-weight-bold" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-clock" }, null, -1))
const _hoisted_14 = { class: "font-weight-bold" }
const _hoisted_15 = { class: "font-weight-bold" }
const _hoisted_16 = {
  key: 1,
  id: "skillGapDetails",
  class: "skillgroup-container"
}
const _hoisted_17 = { class: "col text-end" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { id: "plusMetrics" }
const _hoisted_20 = {
  key: 0,
  id: "divPcs",
  class: "col text-start"
}
const _hoisted_21 = { class: "white-background-color padding-left-15 line-height-25" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row white-background-color" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12 text-center" }, [
    /*#__PURE__*/_createElementVNode("b", null, "PCS")
  ])
], -1))
const _hoisted_23 = { class: "row white-background-color" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-sm-6",
  id: "count-container"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "census-data" }, "Count"),
  /*#__PURE__*/_createTextVNode(": ")
], -1))
const _hoisted_25 = { class: "col-sm-6 text-end text-padding" }
const _hoisted_26 = { class: "digits" }
const _hoisted_27 = { class: "row white-background-color" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-sm-6",
  id: "rating-container"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "census-data" }, "Rating"),
  /*#__PURE__*/_createTextVNode(": ")
], -1))
const _hoisted_29 = { class: "col-sm-6 text-end text-padding" }
const _hoisted_30 = { class: "digits" }
const _hoisted_31 = { class: "row white-background-color" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-sm-6",
  id: "level-container"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "census-data" }, "Level"),
  /*#__PURE__*/_createTextVNode(": ")
], -1))
const _hoisted_33 = { class: "col-sm-6 text-end text-padding" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row white-background-color" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-sm-6",
    id: "rating-container"
  }, " "),
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6 text-end" }, "   ")
], -1))
const _hoisted_35 = { class: "col text-start" }
const _hoisted_36 = { class: "line-height-25 padding-right-15" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "census-data" }, "Staff-to", -1))
const _hoisted_38 = { class: "metric" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "census-data" }, "Actual", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "census-data" }, "Forecast", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "census-data" }, "Volume Level", -1))
const _hoisted_42 = { class: "digits" }
const _hoisted_43 = { class: "digits" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "padding-right-15" }, null, -1))
const _hoisted_45 = {
  key: 0,
  style: {"margin-top":"0 !important","margin-bottom":"12px !important"}
}
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col text-end" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = {
  key: 1,
  style: {"margin-top":"0 !important","margin-bottom":"12px !important"}
}
const _hoisted_50 = {
  key: 2,
  class: "row"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-auto skill-gaps-container" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "skill-gaps" })
], -1))
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { style: {"margin-top":"0 !important","margin-bottom":"12px !important"} }, null, -1))
const _hoisted_54 = { class: "row" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-2 text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { id: "selected-skill" })
], -1))
const _hoisted_56 = { class: "row col" }
const _hoisted_57 = { class: "col text-end row-padding" }
const _hoisted_58 = {
  key: 0,
  id: "care-assignment-sheet-print"
}
const _hoisted_59 = { "aria-hidden": "true" }
const _hoisted_60 = {
  key: 1,
  class: "actionable-refresh",
  id: "actionable-refresh"
}
const _hoisted_61 = { "aria-hidden": "true" }
const _hoisted_62 = {
  key: 2,
  class: "clockin-status",
  id: "btnClockInStatus"
}
const _hoisted_63 = { "aria-hidden": "true" }
const _hoisted_64 = {
  key: 3,
  class: "notes",
  id: "actionable-note-id"
}
const _hoisted_65 = { "aria-hidden": "true" }
const _hoisted_66 = {
  key: 4,
  class: "save-as-excel",
  id: "saveAsExcel"
}
const _hoisted_67 = { "aria-hidden": "true" }
const _hoisted_68 = {
  key: 1,
  id: "header-message",
  class: "text-center mt-3"
}
const _hoisted_69 = { id: "header-message-text" }
const _hoisted_70 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_PlusMetrics = _resolveComponent("PlusMetrics")!
  const _component_neu_col = _resolveComponent("neu-col")!
  const _component_neu_row = _resolveComponent("neu-row")!
  const _component_ToasterPopup = _resolveComponent("ToasterPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_font_awesome_icon, {
          spin: true,
          icon: ['fas', 'circle-notch'],
          size: "lg"
        })
      ]),
      _hoisted_4
    ], 512), [
      [_vShow, _ctx.isShowLoader]
    ]),
    (_ctx.isShowHeaderContent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              id: "divSummary",
              class: _normalizeClass([_ctx.headerViewModel.pcsEnabled ? 'col-sm-6' : 'col-sm-7'])
            }, [
              (_ctx.headerViewModel.showDeptSummary)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("h5", null, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.fullFacilityName()), 1)
                    ]),
                    _createElementVNode("h6", null, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.headerViewModel.serviceLineName), 1),
                      _createTextVNode(" > "),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.fullDepartmentName()), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_11,
                      _createTextVNode(),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.startDate()), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_13,
                      _createTextVNode(),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.startTime()), 1),
                      _createTextVNode(" - "),
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.endTime()), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.headerViewModel.showSkillAggregation)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", _hoisted_17, [
              (_ctx.headerViewModel.pmEnabled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_PlusMetrics, { plusMetricsData: _ctx.plusMetricsData }, null, 8, ["plusMetricsData"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.headerViewModel.pcsEnabled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.headerViewModel.pcsTotalCensus != null ? _ctx.headerViewModel.pcsTotalCensus: '00'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.headerViewModel.pcsRating != null ? _ctx.headerViewModel.pcsRating: '00'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.headerViewModel.pcsRangeName), 1)
                      ])
                    ]),
                    _hoisted_34
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createVNode(_component_neu_row, { class: "row text-center white-background-color" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_neu_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createElementVNode("b", null, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.statDescription), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_neu_row, { class: "row white-background-color" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_neu_col, {
                      xxl: "3",
                      xl: "6",
                      lg: "12",
                      md: "3",
                      sm: "6",
                      cols: "12",
                      id: "staffTo-container",
                      class: _normalizeClass([_ctx.isAddCensusClsStaffTo ? 'census': ''])
                    }, {
                      default: _withCtx(() => [
                        _hoisted_37,
                        _createTextVNode(": ")
                      ]),
                      _: 1
                    }, 8, ["class"]),
                    _createVNode(_component_neu_col, {
                      xxl: "3",
                      xl: "6",
                      lg: "12",
                      md: "3",
                      sm: "6",
                      cols: "12",
                      class: "text-end text-padding"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.headerViewModel.staffTo), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_neu_row, { class: "row white-background-color" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_neu_col, {
                      xxl: "3",
                      xl: "6",
                      lg: "12",
                      md: "3",
                      sm: "6",
                      cols: "12",
                      class: "col-sm-7",
                      id: "actual-container"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_39,
                        _createTextVNode(":")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_neu_col, {
                      xxl: "3",
                      xl: "6",
                      lg: "12",
                      md: "3",
                      sm: "6",
                      cols: "12",
                      class: "col-sm-5 text-end text-padding"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["metric", [_ctx.isAddCensusClsActual ? 'census': '']]),
                          id: "spanActual"
                        }, _toDisplayString(_ctx.headerViewModel.actualCensus), 3)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_neu_row, { class: "row white-background-color" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_neu_col, {
                      xxl: "3",
                      xl: "6",
                      lg: "12",
                      md: "3",
                      sm: "6",
                      cols: "12",
                      class: "col-sm-7",
                      id: "forecast-container"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_40,
                        _createTextVNode(": ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_neu_col, {
                      xxl: "3",
                      xl: "6",
                      lg: "12",
                      md: "3",
                      sm: "6",
                      cols: "12",
                      class: "col-sm-5 text-end text-padding"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          id: "spanforecast",
                          class: _normalizeClass(["metric", [_ctx.isAddCensusClsForecast ? 'census': '']])
                        }, _toDisplayString(_ctx.headerViewModel.forecastCensus), 3)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_neu_row, { class: "row white-background-color" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_neu_col, {
                      xxl: "3",
                      xl: "6",
                      lg: "12",
                      md: "3",
                      sm: "6",
                      cols: "12",
                      class: "col-sm-7",
                      id: "volumeLevel-container"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_41,
                        _createTextVNode(": ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_neu_col, {
                      xxl: "3",
                      xl: "6",
                      lg: "12",
                      md: "3",
                      sm: "6",
                      cols: "12",
                      class: "col-sm-5 text-end text-padding"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.censusLow), 1),
                        _createTextVNode("-"),
                        _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.censusPeak), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _hoisted_44
          ]),
          (_ctx.headerViewModel.pcsEnabled)
            ? (_openBlock(), _createElementBlock("hr", _hoisted_45))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              (_ctx.headerViewModel.pcsEnabled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                    _createElementVNode("div", null, [
                      _createTextVNode("Last Census Update: "),
                      _createElementVNode("span", null, _toDisplayString(_ctx.lastCensusUpdateStartDateTime()), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.headerViewModel.showSkillGaps)
            ? (_openBlock(), _createElementBlock("hr", _hoisted_49))
            : _createCommentVNode("", true),
          (_ctx.headerViewModel.showSkillGaps)
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, _hoisted_52))
            : _createCommentVNode("", true),
          _hoisted_53,
          _createElementVNode("div", _hoisted_54, [
            _hoisted_55,
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                (_ctx.headerViewModel.showCareAssignmentPrint)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_58, [
                      _createElementVNode("i", _hoisted_59, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: ['fas', 'file-pdf'],
                          size: "sm"
                        })
                      ]),
                      _createElementVNode("a", {
                        class: "actionable-menu-link",
                        href: "#",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadCareAssignmentSheet('PDF')))
                      }, "Care Assignment Sheet")
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.headerViewModel.showActionableRefresh)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_60, [
                      _createTextVNode("  |  "),
                      _createElementVNode("i", _hoisted_61, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: ['fas', 'sync-alt'],
                          size: "sm"
                        })
                      ]),
                      _createElementVNode("a", {
                        class: "actionable-menu-link",
                        href: "#",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.refreshActionablePopup && _ctx.refreshActionablePopup(...args)))
                      }, "Refresh")
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.headerViewModel.showClockInStatues)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_62, [
                      _createTextVNode("  |  "),
                      _createElementVNode("i", _hoisted_63, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: ['far', 'clock'],
                          size: "sm"
                        })
                      ]),
                      _createElementVNode("a", {
                        class: "actionable-menu-link",
                        href: "#",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.loadClockInStatus && _ctx.loadClockInStatus(...args)))
                      }, "Clock-In-Details")
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.headerViewModel.showNotes)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_64, [
                      _createTextVNode("  |  "),
                      _createElementVNode("i", _hoisted_65, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: ['far', 'sticky-note'],
                          size: "sm"
                        })
                      ]),
                      _createElementVNode("a", {
                        class: "actionable-menu-link",
                        href: "#",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.loadDepartmentSummaryNote && _ctx.loadDepartmentSummaryNote(...args)))
                      }, "Notes")
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.headerViewModel.showSaveAsExcel)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_66, [
                      _createTextVNode("  |  "),
                      _createElementVNode("i", _hoisted_67, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: ['far', 'file-excel'],
                          size: "sm"
                        })
                      ]),
                      _createElementVNode("a", {
                        class: "actionable-menu-link",
                        href: "#",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadCareAssignmentSheet('Excel')))
                      }, "Export to Excel")
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isShowHeaderMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
          _createElementVNode("p", _hoisted_69, _toDisplayString(_ctx.headerMessageText), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isToasterVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
          _createVNode(_component_ToasterPopup, {
            onCloseModal: _ctx.closeToasterPopup,
            msgValue: _ctx.msgValue,
            classFlag: _ctx.classFlag
          }, null, 8, ["onCloseModal", "msgValue", "classFlag"])
        ]))
      : _createCommentVNode("", true)
  ]))
}